import { render, staticRenderFns } from "./LeftMenuTab.vue?vue&type=template&id=e50db330&scoped=true"
import script from "./LeftMenuTab.vue?vue&type=script&lang=ts"
export * from "./LeftMenuTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50db330",
  null
  
)

export default component.exports